<template>
    <div class="py-4 shape_block">
        <h4 class="mb-4 text-center pb-2 font-active">Shop By Shape</h4>
        <p class="text-center mb-4 pb-4" v-if="$country.is_india">Diamonds come in various shapes. Take a detailed look at all the popular diamond shapes most commonly used to create <NuxtLink :to="localePath('/engagement-rings')">lab diamond engagement rings</NuxtLink> and <NuxtLink :to="localePath('/fine-jewelry')">{{ $t('jewelry') }}</NuxtLink>.</p>
        <p class="text-center mb-4 pb-4" v-else>Diamonds come in various shapes. Take a detailed look at all the popular diamond shapes most commonly used to create lab diamond engagement rings and {{ $t('jewelry') }}.</p>
        <div class="shape_main">
            <div class="shape_flex">
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/round.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/round.jpg" alt="Round Cut Diamonds">
                        </picture>
                        <span>round</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/round.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/round.jpg" alt="Round Cut Diamonds">
                            </picture>
                            <span>round</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Classic brilliant round cut diamonds known for their magnificent sparkle and shine</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })" class="radious_four">shop round diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/oval.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/oval.jpg" alt="Oval Cut Diamonds">
                        </picture>
                        <span>oval</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/oval.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/oval.jpg" alt="Oval Cut Diamonds">
                            </picture>
                            <span>oval</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Trendy elongated diamonds shaped to perfection.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })" class="radious_four">shop oval diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/pear.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/pear.jpg" alt="Pear Cut Diamonds">
                        </picture>
                        <span>pear</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/pear.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/pear.jpg" alt="Pear Cut Diamonds">
                            </picture>
                            <span>pear</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Unique teardrop shaped diamonds radiating bright sparkle.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })" class="radious_four">shop pear diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/cushion.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/cushion.jpg" alt="Cushion Cut Diamonds">
                        </picture>
                        <span>cushion</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/cushion.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/cushion.jpg" alt="Cushion Cut Diamonds">
                            </picture>
                            <span>cushion</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Contemporary blend of cuts offering a timeless sophistication.  </p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })" class="radious_four">shop cushion diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/princess.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/princess.jpg" alt="Princess Cut Diamonds">
                        </picture>
                        <span>princess</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/princess.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/princess.jpg" alt="Princess Cut Diamonds">
                            </picture>
                            <span>princess</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Modified square brilliant cuts with an out-of-this-world-shine.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })" class="radious_four">shop princess diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'radiant-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/radiant.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/radiant.jpg" alt="Radiant Cut Diamonds">
                        </picture>
                        <span>radiant</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'radiant-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/radiant.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/radiant.jpg" alt="Radiant Cut Diamonds">
                            </picture>
                            <span>radiant</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Sparkling modern cut diamonds crafted with trimmed edges.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'radiant-cut-diamond' } })" class="radious_four">shop radiant diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/emerald.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/emerald.jpg" alt="Emerald Cut Diamonds">
                        </picture>
                        <span>emerald</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/emerald.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/emerald.jpg" alt="Emerald Cut Diamonds">
                            </picture>
                            <span>emerald</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Rectangular-shaped step cuts encapsulating grace and vigor.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })" class="radious_four">shop emerald diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/heart.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/heart.jpg" alt="Heart Cut Diamonds">
                        </picture>
                        <span>heart</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/heart.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/heart.jpg" alt="Heart Cut Diamonds">
                            </picture>
                            <span>heart</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Unique heart-shaped diamonds representing eternal love.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })" class="radious_four">shop heart diamonds</NuxtLink>
                    </div>
                </div>
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/asscher.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/asscher.jpg" alt="Asscher Cut Diamonds">
                        </picture>
                        <span>asscher</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/asscher.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/asscher.jpg" alt="Asscher Cut Diamonds">
                            </picture>
                            <span>asscher</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Vintage-styled diamonds emitting sophisticated brilliance.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })" class="radious_four">shop asscher diamonds</NuxtLink>
                    </div>
                </div> 
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })" class="for_mobile">
                        <picture>
                        <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/marquise.webp">
                        <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/marquise.jpg" alt="Marquise Cut Diamonds">
                        </picture>
                        <span>marquise</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })">
                            <picture>
                            <source width="64" height="64" type="image/webp" srcset="~/assets/shapes/marquise.webp">
                            <img loading="lazy" width="64" height="64" type="image/jpeg" src="~/assets/shapes/marquise.jpg" alt="Marquise Cut Diamonds">
                            </picture>
                            <span>marquise</span>
                        </NuxtLink>
                    </div>
                    <div class="shape_upper for_desktop radious_eight">
                        <p>Unique and graceful diamond cuts crafted with a vintage aesthetic.</p>
                        <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })" class="radious_four">shop marquise diamonds</NuxtLink>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath();
    const { $country } = useNuxtApp();
</script>

<style scoped>
.shape_flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
}
.slide_box{
    position: relative;
    cursor: pointer;
}
.shape_area {
    text-align: center;
}
.shape_upper p {
    color: #6a6161;
    font-size: 17px;
    text-align: center;
    width: 100;
    text-align: center;
}
.shape_upper a {
    display: block;
    color: #000;
    text-transform: uppercase;
    font-size: 14px;
    border: 1px solid #000;
    padding: 8px 14px;
    font-weight: 600;
    width: 100%;
    text-align: center;
}
.shape_upper {
    position: absolute;
    background: #f5f2f2;
    min-width: 360px;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 25px);
    padding: 25px;
    z-index: 99;
    display: none;
}
.shape_upper:before {
    position: absolute;
    height: 30px;
    width: 30px;
    background: #f5f2f2;
    content: "";
    top: 0;
    left: 50%;
    transform: translate(-50%, -15px) rotate(45deg);
    z-index: -1;
}
.slide_box:hover .shape_upper{
    display: block;
}
button{
    background: #2a4437;
    color: #fff;
    border-color: #2a4437;
}
h4{
    font-size: 30px;
}
p{
    font-weight: 500;
    color: #6a6161;
}
p a{
    text-decoration: underline;
}
.shape_area {
    text-align: center;
}
 span {
    display: block;
    text-align: center;
    color: #000;
    text-transform: capitalize;
    font-size: 16px;
    margin-top: 15px;
    font-weight: 500;
}
@media(max-width: 992px){
    .shape_upper{
        width: 280px;
    }
    .shape_upper p{
        font-size: 14px;
    }
    .shape_main {
        overflow-x: scroll;
        overflow-y: hidden;
    }
    .shape_flex {
        width: 1024px;
    }
    p br{
        display: none;
    }
}
@media(max-width: 767px){
    .test_block {
        margin: 7% 0;
    }
    h4{
        font-size: 24px;
    }
    .shape_block {
        padding: 0 7%;
    }

}



</style>
